import {IBaseLookup} from "./Ibase.lookup";

export namespace InterpretationOption {

    export const lookupName: string = "InterpretationOption";

    export interface InterpretationOption {
        interpretationOptionKey: number;
        description: string;
        active: string;
        lastUpdated: Date;
        goToThirdReader: string;
        availableToThirdReader: string;
        defaultSeverity: number;
        overallInterpretation: string;
        code: string;
    }

    export interface InterpOptionXSpsCode {
        interpOptionXSpsCodeKey: number;
        interpretationOptionKey: number;
        spsCodeKey: number;
        active: string;
        lastUpdated: Date;
        displaySortOrder: number;
    }

    export interface InterpretationOptionDS extends IBaseLookup {
        interpretationOption: InterpretationOption[];
        interpOptionXSpsCode: InterpOptionXSpsCode[];
    }
}
